'use strict';
angular.module('schoolLinqApp').directive('accountFundPairCheck', [
	function () {
		const fundPosition = 0;
		const wildCardSymbol = '?';

		let getFundPartFromAccount = function (acc) {
			if (typeof acc !== 'string') return null;
			let parts = acc.split('.');
			if (parts.length < fundPosition) return null;
			return parts[fundPosition];
		};

		let link = function ($scope, $element, $attrs, ctrl) {
			let validate = function (viewValue) {
				let comparisonModel = $attrs.accountFundPairCheck;
				if (!viewValue && !comparisonModel) {
					ctrl.$setValidity('accountFundPairCheck', true);
				} else {
					let leftFund = getFundPartFromAccount(viewValue);
					let rigtFund = getFundPartFromAccount(comparisonModel);
					const valid =
						(leftFund === null && rigtFund === null) ||
						(leftFund === wildCardSymbol && rigtFund === wildCardSymbol) ||
						(leftFund !== wildCardSymbol && rigtFund !== wildCardSymbol);

					ctrl.$setValidity('accountFundPairCheck', valid);
				}
				return viewValue;
			};

			ctrl.$parsers.unshift(validate);
			ctrl.$formatters.push(validate);

			$attrs.$observe('accountFundPairCheck', function (comparisonModel) {
				return validate(ctrl.$viewValue);
			});
		};

		return {
			require: 'ngModel',
			link: link,
		};
	},
]);
